class ProductVariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    const selectedVariantJson = this.querySelector('[data-selected-variant-json]');

    if (!selectedVariantJson) return;

    if (!this.currentVariant && selectedVariantJson) {
      try {
        this.currentVariant = JSON.parse(selectedVariantJson.textContent);
      } catch (error) {
        this.currentVariant = null;
      }
    }

    window.requestAnimationFrame(() => this.updateMedia());
  }

  onVariantChange(event) {
    if (this.isHighVariantProduct()) {
      this.onHighVariantChange(event);
      return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.selectAvailableStoneSize(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updatePickupBanner();
      this.renderProductInfo();
      if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
        this.updateURL();
      }
    }
  }

  isHighVariantProduct() {
    return Number(this.dataset.variantsCount) > Number(this.dataset.loadedVariantsCount);
  }

  onHighVariantChange(event) {
    const changedControl = event.target.tagName === 'SELECT'
      ? event.target.options[event.target.selectedIndex]
      : event.target;
    const requestedProductUrl = changedControl.dataset.productUrl || this.dataset.productUrl;
    const optionValueIds = window.MDProductMediaGroups
      ? window.MDProductMediaGroups.collectOptionValueIds(this)
      : [];

    if (!optionValueIds.length || !requestedProductUrl) {
      this.setUnavailable();
      return;
    }

    const requestId = (this.variantRequestId || 0) + 1;
    const sectionId = this.dataset.originalSection || this.dataset.productId;
    const requestUrl = window.MDProductMediaGroups.buildOptionValuesUrl(
      requestedProductUrl,
      optionValueIds,
      sectionId
    );
    const changedControlId = event.target.id;
    this.variantRequestId = requestId;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this.variantRequestId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector(
          `${this.tagName.toLowerCase()}[data-product-id="${this.dataset.productId}"]`
        );
        const selectedVariantJson = source?.querySelector('[data-selected-variant-json]');

        if (!source || !selectedVariantJson) return;

        this.currentVariant = JSON.parse(selectedVariantJson.textContent);
        this.variantData = null;
        this.innerHTML = source.innerHTML;
        this.dataset.productUrl = source.dataset.productUrl || requestedProductUrl;

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
          return;
        }

        this.updateMedia();
        this.updateVariantInput();
        this.updatePickupAvailability();
        this.updatePickupBanner();
        this.updateProductInfoFromResponse(responseText);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);

        if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
          this.updateURL();
        }

        if (changedControlId) {
          this.querySelector(`#${CSS.escape(changedControlId)}`)?.focus();
        }
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  selectAvailableStoneSize(event) {
    if (this.currentVariant || !event?.target.closest('.md-product-option--diamond-shape')) return;

    const stoneSizeSelect = this.querySelector('select[name="options[Stone Size]"]');
    if (!stoneSizeSelect) return;

    const wrappers = Array.from(this.querySelectorAll('fieldset'));
    const stoneSizeIndex = wrappers.indexOf(stoneSizeSelect.closest('fieldset'));
    if (stoneSizeIndex < 0) return;

    const matchingVariants = this.getVariantData().filter((variant) =>
      variant.options.every((value, index) => index === stoneSizeIndex || value === this.options[index])
    );
    const fallback = matchingVariants.find((variant) => variant.available) || matchingVariants[0];
    if (!fallback) return;

    stoneSizeSelect.value = fallback.options[stoneSizeIndex];
    this.updateOptions();
    this.updateMasterId();
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (window.MDProductMediaGroups?.update(this, this.currentVariant)) return;
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.productId}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    const itemact = document.querySelectorAll('.proFeaturedImage .item');
    for (var i = 0; i < itemact.length; i++) {
      itemact[i].classList.remove('act')
    }
    newMedia.classList.add('act');
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.productUrl}?variant=${this.currentVariant.id}`);
  }


  updatePickupBanner() {
    if (!this.currentVariant) return;
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const pickupJson = productForm.querySelector('[data-md-pickup-json]');
    const pickupBanner = productForm.querySelector('[data-md-pickup-banner]');
    if (!pickupJson || !pickupBanner) return;

    let pickupData = {};
    try {
      pickupData = JSON.parse(pickupJson.textContent);
    } catch (error) {
      return;
    }

    const variantPickup = pickupData[String(this.currentVariant.id)] || {};
    const isReady = variantPickup.ready === true || variantPickup.ready === 'true';
    pickupBanner.hidden = !isReady;

    const message = pickupBanner.querySelector('[data-md-pickup-message]');
    if (message && variantPickup.message) {
      message.textContent = variantPickup.message;
    }
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  }

  updateVariantStatuses() {
    const firstOptionWrapper = this.querySelector('fieldset, .product-form__input');
    const firstOptionValue = this.getSelectedOptionValue(firstOptionWrapper);
    const selectedOptionOneVariants = this.variantData.filter(variant => firstOptionValue === variant.option1);
    const inputWrappers = [...this.querySelectorAll('fieldset, .product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = this.getSelectedOptionValue(inputWrappers[index - 1]);
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  getSelectedOptionValue(wrapper) {
    if (!wrapper) return '';
    const select = wrapper.querySelector('select');
    if (select) return select.value;
    const checkedInput = wrapper.querySelector('input[type="radio"]:checked, :checked');
    return checkedInput ? checkedInput.value : '';
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId;
    fetch(`${this.dataset.productUrl}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        this.updateProductInfoFromResponse(responseText);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }

  updateProductInfoFromResponse(responseText) {
    const id = `ProductPrice-${this.dataset.productId}`;
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const destination = document.getElementById(id);
    const source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.dispatchEvent(new CustomEvent('md:product-price-updated', {
      detail: { productId: this.dataset.productId }
    }));

    const variantId = this.currentVariant?.id;
    const productSelect = document.getElementById('productSelect');
    const variantOption = variantId ? productSelect?.querySelector(`[value="${variantId}"]`) : null;
    const sku = variantOption?.getAttribute('data-sku') || this.currentVariant?.sku;
    const variantSku = document.getElementById('variantSku');
    if (variantSku && sku != null) {
      variantSku.textContent = sku;
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variantId = this.currentVariant?.id || document.getElementById('variant_id')?.getAttribute('value');
      const variantOption = variantId
        ? document.getElementById('productSelect')?.querySelector(`[value="${variantId}"]`)
        : null;
      const inventoryPolicy = variantOption?.getAttribute('data-inventory_policy') || this.currentVariant?.inventory_policy;
      const inventoryManagement = variantOption?.getAttribute('data-inventory_management') || this.currentVariant?.inventory_management;
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('product-variant-dropdown', ProductVariantDropdown);

class ProductVariantSwatch extends ProductVariantDropdown {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      const isAvailable = listOfAvailableOptions.includes(input.getAttribute('value'));
      if (input.tagName === 'OPTION') {
        input.disabled = !isAvailable;
      } else if (isAvailable) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => this.getSelectedOptionValue(fieldset));
  }
}

customElements.define('product-variant-swatch', ProductVariantSwatch);

class ProductVariantSelectsStick extends ProductVariantDropdown {
  constructor() {
    super();
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-sticky-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(`${this.dataset.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPriceStick-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-sticky-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const inventoryPolicy = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_policy');
      const inventoryManagement = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_management');
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addTobag;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-sticky-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
}

customElements.define('product-variant-selects-stick', ProductVariantSelectsStick);
